import React from 'react';
import { BellIcon, AlertTriangleIcon, CheckCircle2Icon } from 'lucide-react';
const alerts = [{
  id: 1,
  type: 'warning',
  message: 'Tiempo de respuesta elevado en API de pagos',
  time: 'Hace 10 minutos'
}, {
  id: 2,
  type: 'success',
  message: 'Sincronización de documentos completada',
  time: 'Hace 15 minutos'
}, {
  id: 3,
  type: 'warning',
  message: 'Certificado SSL próximo a expirar',
  time: 'Hace 1 hora'
}];
export const AlertsPanel = () => {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-451">
      <div className="flex items-center justify-between mb-4" data-id="element-452">
        <h2 className="text-lg font-semibold" data-id="element-453">Alertas Recientes</h2>
        <div className="relative" data-id="element-454">
          <BellIcon className="h-5 w-5 text-gray-400" data-id="element-455" />
          <span className="absolute -top-1 -right-1 h-2 w-2 bg-red-500 rounded-full" data-id="element-456"></span>
        </div>
      </div>
      <div className="space-y-4" data-id="element-457">
        {alerts.map(alert => <div key={alert.id} className={`p-4 rounded-lg flex items-start gap-3 ${alert.type === 'warning' ? 'bg-yellow-50' : 'bg-green-50'}`} data-id="element-458">
            {alert.type === 'warning' ? <AlertTriangleIcon className="h-5 w-5 text-yellow-500 mt-0.5" data-id="element-459" /> : <CheckCircle2Icon className="h-5 w-5 text-green-500 mt-0.5" data-id="element-460" />}
            <div data-id="element-461">
              <p className={`font-medium ${alert.type === 'warning' ? 'text-yellow-700' : 'text-green-700'}`} data-id="element-462">
                {alert.message}
              </p>
              <p className="text-sm text-gray-500 mt-1" data-id="element-463">{alert.time}</p>
            </div>
          </div>)}
      </div>
    </div>;
};